/**
 * Privacy options shared by both Sentry inits. Coaching notes, goals and NOVA
 * chats are readable only by the person and their coach, so error replays show
 * layout and clicks only, and events carry no default personal data (IPs,
 * request headers, cookies). Users are identified only through the explicit
 * `setUser` call in `~/lib/server/sentry-context`.
 */
export const SENTRY_SEND_DEFAULT_PII = false;

export const SENTRY_REPLAY_PRIVACY = {
  maskAllText: true,
  blockAllMedia: true,
} as const;
